import { Chip } from '@winnin/winnin_ui.components.chip'
import { Loading } from '@winnin/winnin_ui.components.loading'
import { Title } from '@winnin/winnin_ui.components.title'

import { InlineDropdown, InputAction } from 'components'
import { CreateNewDashboardButton } from 'components/CreateNewDashboardButton'
import { DashboardCard, DashboardCardSkeleton } from 'components/DashboardCard'
import SortByFilterV2 from 'components/SortByFilterV2'
import { useTranslate } from 'lib/tolgee'
import { DashboardListEmptyState } from 'modules/dashboard'
import { TOLGEE_GLOBALS } from 'utils'

import { SORT_BY_OPTIONS, SORT_BY_TYPE } from './dashboard-list.consts'
import type { IDashboardList } from './dashboard-list.types'

import './dashboard-list.styles.scss'

export const DashboardListView = ({
  handleChangeSearch,
  handleChipClick,
  handleFilterChange,
  search,
  trackSortBy,
  createdByDone,
  createdByDraft,
  createdByZai,
  typeSelect,
  loading,
  isUserViewer,
  hasMore,
  sentryRef,
  jobs,
  jobsRows,
  jobsValidationLimit,
  maxJobs,
  error,
  refetch,
  handleClickOnCreateNewDashboard,
  handleSearch,
  isFolder,
  isEmpty,
  shouldDisplayEmptyState,
}: IDashboardList) => {
  const t = useTranslate()

  if (error) {
    return (
      <p>
        Error loading jobs <button onClick={refetch}>Refetch</button>
      </p>
    )
  }

  return (
    <div className="DashboardList">
      <Title tag="h2">
        {t(
          TOLGEE_GLOBALS.dashboardWithPlural({
            dashboardCount: jobsRows,
          })
        )}
      </Title>
      <div className="JobsWithZaiUseCases-form">
        <InputAction
          placeholder={t(TOLGEE_GLOBALS.search)}
          value={search}
          onChange={handleChangeSearch}
          onClick={handleSearch}
          name="search"
          icon="search"
        />

        <div className="JobsWithZaiUseCases-sortAndFilters">
          <div className="JobsWithZaiUseCases-sort">
            <SortByFilterV2 options={SORT_BY_OPTIONS} additionalTracking={trackSortBy} />
            <InlineDropdown
              onChange={option => handleFilterChange('typeSelect', option.value)}
              options={SORT_BY_TYPE}
              label={t(TOLGEE_GLOBALS.type)}
              selected={SORT_BY_TYPE.find(option => option.value === typeSelect) || SORT_BY_TYPE[0]}
            />
          </div>

          <div className="JobsWithZaiUseCases-filters">
            <Chip
              title={t(TOLGEE_GLOBALS.draft)}
              isActive={!!createdByDraft}
              handleClick={() => handleChipClick('draft')}
            />
            <Chip
              title={t(TOLGEE_GLOBALS.done)}
              isActive={!!createdByDone}
              handleClick={() => handleChipClick('done')}
            />
            <Chip
              title={t(TOLGEE_GLOBALS.zai)}
              isActive={!!createdByZai}
              handleClick={() => handleChipClick('createdByZai')}
            />
          </div>
        </div>
      </div>

      <div className="boards-grid">
        <div className="hiddenOnMobile">
          {!(isEmpty && isFolder) && (
            <CreateNewDashboardButton
              onClick={handleClickOnCreateNewDashboard}
              disabled={isUserViewer}
              disabledMessage={
                jobsValidationLimit
                  ? t(TOLGEE_GLOBALS.newJobLimitReached({ jobsCount: jobsRows, jobsLimit: maxJobs }))
                  : undefined
              }
            />
          )}
        </div>

        {loading ? (
          <>
            {Array.from({ length: 11 }).map((_, index) => (
              <DashboardCardSkeleton key={index} />
            ))}
          </>
        ) : (
          <>
            {!isEmpty &&
              jobs?.map(job => {
                return <DashboardCard key={job.id} job={job} />
              })}
            {shouldDisplayEmptyState && <DashboardListEmptyState isViewer={isUserViewer} />}
          </>
        )}
      </div>
      {hasMore && (
        <div ref={sentryRef}>
          <Loading />
        </div>
      )}
    </div>
  )
}
